var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 8.75H10.055L11.0833 9.55797V3.5H11.6667C11.9888 3.5 12.25 3.76117 12.25 4.08333V11.9583L9.65154 9.91667H4.66667C4.3445 9.91667 4.08333 9.65551 4.08333 9.33333V8.75ZM2.59849 7.58333L0 9.625V0.583333C0 0.26117 0.26117 0 0.583333 0H9.33333C9.65551 0 9.91667 0.26117 9.91667 0.583333V7.58333H2.59849Z",
    fill: "#25262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.bcae2bc98ab6a0a939086bf87f719062.svg";
export { ForwardRef as ReactComponent };